package one.healthium.ricediet.presentation.navigation.today

import androidx.compose.runtime.Composable
import one.healthium.ricediet.presentation.feature.today.TodayScreen

@Composable
fun TodayContent(
    component: TodayComponent,
) {
    TodayScreen(component)
}